export default __webpack_public_path__ + "static/form-grouping-do-272c7257110068f37dd2c605117d95abc437e106c322e9c3b0598682d1194e7d.png";